import { render } from "./WhatsAppMessagesPerAgencyCustomer.vue?vue&type=template&id=a07b1b5c&scoped=true"
import script from "./WhatsAppMessagesPerAgencyCustomer.vue?vue&type=script&lang=js"
export * from "./WhatsAppMessagesPerAgencyCustomer.vue?vue&type=script&lang=js"

import "./WhatsAppMessagesPerAgencyCustomer.vue?vue&type=style&index=0&id=a07b1b5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a07b1b5c"]])

export default __exports__